import React, { FunctionComponent, ReactNode } from 'react';

import classNames from 'classnames';

import styles from './DefaultLayout.scss';
import { useDecision } from '@optimizely/react-sdk';
import { Experiments } from '../../constants/experiments';

type DefaultLayoutProps = {
  slots: {
    featureImage: ReactNode;
    ownerAvatar: ReactNode;
    titles: ReactNode;
    totals: ReactNode;
    callsToAction: ReactNode;
    titlesSupplementary?: ReactNode;
    causeMini: ReactNode;
    main: ReactNode;
    aside: ReactNode;
    teamAndCompany?: ReactNode;
    contentFooterPrimary: ReactNode;
    contentFooterSecondary: ReactNode;
  };
  footerBackgroundColor?: string;
};

const DefaultLayout: FunctionComponent<DefaultLayoutProps> = ({
  slots: {
    titlesSupplementary,
    titles,
    ownerAvatar,
    main,
    contentFooterSecondary,
    contentFooterPrimary,
    causeMini,
    callsToAction,
    aside,
    teamAndCompany,
    featureImage,
    totals,
  },
  footerBackgroundColor,
}) => {
  const [
    { variationKey: MoveSupportersListAboveStoryExperiment },
  ] = useDecision(
    Experiments.MoveSupportersListUpThePage
      .MoveSupportersListUpThePageExperiment.experimentKey,
  );

  const isEnrolledInMoveSupportersList =
    MoveSupportersListAboveStoryExperiment ===
    Experiments.MoveSupportersListUpThePage
      .MoveSupportersListUpThePageExperiment.variations.supportersAboveStory;

  return (
    <>
      <div data-qa="app" className={styles.container}>
        <div className={styles.grid}>
          <section className={styles.featureImage}>{featureImage}</section>

          <article className={styles.title}>
            <section className={styles.pageOwner} data-qa="page-owner">
              <div className={styles.pageOwnerAvatar}>{ownerAvatar}</div>
              <div className={styles.pageOwnerTitles}>{titles}</div>
            </section>
          </article>

          <div className={styles.totalsWrapper}>
            <section className={styles.totals}>{totals}</section>
            <section className={styles.callsToAction}>{callsToAction}</section>
          </div>

          {titlesSupplementary && (
            <section
              className={styles.additional}
              data-qa="title-supplementary-slot"
            >
              <div className={styles.additionalWrapper}>
                {titlesSupplementary}
              </div>
            </section>
          )}

          <section className={styles.causeMini}>{causeMini}</section>

          {isEnrolledInMoveSupportersList && (
            <>
              <aside
                className={classNames(
                  styles.aside,
                  'jg-bdt',
                  'jg-bd--very-light-grey',
                )}
              >
                {aside}
              </aside>

              <main data-qa="main" className={styles.main}>
                {main}
              </main>
            </>
          )}

          {!isEnrolledInMoveSupportersList && (
            <>
              <main data-qa="main" className={styles.main}>
                {main}
              </main>

              <aside
                className={classNames(
                  styles.aside,
                  'jg-bdt',
                  'jg-bd--very-light-grey',
                )}
              >
                {aside}
              </aside>
            </>
          )}

          {teamAndCompany && (
            <section
              className={styles.teamAndCompany}
              data-qa="team-and-company-slot"
            >
              {teamAndCompany}
            </section>
          )}
        </div>
      </div>
      <div className={styles.bottomWrapper}>
        <div className={styles.bottom}>{contentFooterPrimary}</div>
      </div>
      <div
        className={styles.bottomWrapper}
        style={{ backgroundColor: footerBackgroundColor }}
      >
        <div className={styles.bottom}>{contentFooterSecondary}</div>
      </div>
    </>
  );
};

export default DefaultLayout;
